import { render, staticRenderFns } from "./WholesalerMenuView.vue?vue&type=template&id=6a028782"
import script from "./WholesalerMenuView.vue?vue&type=script&lang=ts"
export * from "./WholesalerMenuView.vue?vue&type=script&lang=ts"
import style0 from "./WholesalerMenuView.vue?vue&type=style&index=0&id=6a028782&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports